import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import IconComponent from '../button/IconComponent';
import TooltipComponent from '../utils/TooltipComponent'
import ButtonComponent from '../button/ButtonComponent'
import AddButtonComponent from '../button/AddButtonComponent'
import FilterButtonComponent from '../button/FilterButtonComponent'
import SearchComponent from '../utils/SearchComponent';

const TitleBoxComponent = ({ titleName, iconName, homeLink,
  handleSearchText,
  searchHandleNavigate,
  handleKeyPress,
  handleClickAddAction,
  handleClickFilterAction,
  hidden }) => {
  const navigate = useNavigate();

  if (hidden) return null;

  return (
    <div class="d-md-flex justify-space-between border-b-6 border-gray-200 dark:border-dark-5 p-1">
      <div class="flex">
        {
          homeLink &&
          <div class="">
            <TooltipComponent content="Home" id="home-tooltip" placement="bottom">
              <ButtonComponent type="button" color="primary mr-1 mb-2"
                onClick={() => navigate("/" + homeLink)}
              >
                <IconComponent icon="nimbus:home" color='white' height="18" />
              </ButtonComponent>
            </TooltipComponent>
          </div>
        }
        <div class="flex ml-5 pt-5">
          {iconName && <IconComponent icon={iconName} color='gray' />} &nbsp;&nbsp;
          <h2 className="text-lg font-medium truncate mr-5">
            {titleName}
          </h2>
        </div>
      </div>

      <div class="flex">
        {handleSearchText && (
          <div className="flex ml-5 mr-10">
            <SearchComponent
              onChange={handleSearchText}
              onClick={searchHandleNavigate}
              onKeyPress={handleKeyPress}
            />
          </div>
        )}
        {handleClickAddAction &&
          <AddButtonComponent onClick={handleClickAddAction}>
            Add
          </AddButtonComponent>
        }
        {handleClickFilterAction &&
          <FilterButtonComponent onClick={handleClickFilterAction}>
            Filter
          </FilterButtonComponent>
        }
      </div>

    </div>
  );
};

TitleBoxComponent.propTypes = {
  titleName: PropTypes.string,
  iconName: PropTypes.string,
  homeLink: PropTypes.string,
  handleSearchText: PropTypes.func,
  searchHandleNavigate: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleClickAddAction: PropTypes.func,
  handleClickFilterAction: PropTypes.func,
  hidden: PropTypes.bool,
};

TitleBoxComponent.defaultProps = {
  titleName: '',
  iconName: '',
  hidden: false,
};

export default TitleBoxComponent;
